import { hasApiErrorCode } from '@peanuds/shared';

export const BENEFICIARY_NOT_ACTIVE_CODE = 'BENEFICIARY.NOT_ACTIVE';

export const isBeneficiaryNotActiveError = (error: unknown): boolean =>
  hasApiErrorCode(error, BENEFICIARY_NOT_ACTIVE_CODE);
